var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chevron_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7327_501393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 16,
    width: 16,
    height: 16,
    transform: "rotate(90 16 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7327_501393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23431 5.83588C4.54673 5.52346 5.05327 5.52346 5.36569 5.83588L8 8.47019L10.6343 5.83588C10.9467 5.52346 11.4533 5.52346 11.7657 5.83588C12.0781 6.1483 12.0781 6.65483 11.7657 6.96725L8.56569 10.1672C8.25327 10.4797 7.74673 10.4797 7.43431 10.1672L4.23431 6.96725C3.9219 6.65483 3.9219 6.1483 4.23431 5.83588ZM7.71716 9.31872L8 9.60156L8.28284 9.31872C8.12663 9.47493 7.87337 9.47493 7.71716 9.31872Z",
    fill: "#051123"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown_icon.2592b1d444fa0a5a10d921c983854c3f.svg";
export { ForwardRef as ReactComponent };